.back-to-merchant-wrapper {
  border: 1px solid lightgray;
  border-radius: 5px;

  margin-top: 2rem;
  padding: 1.2rem;

  display: flex;
  justify-content: center;
  gap: 1rem;

  color: gray;
  font-size: 1.4rem;
  font-weight: 600;
  text-decoration: none;

  &:hover {
    background-color: #404040;
    border-color: #404040;
    color: white;
  }
}